<script>
	export let header;
</script>

<div class="graphic-header">
	<h1 class="graphic-hed">{header.hed}</h1>

	{#if header.subhed}
		<h3 class="graphic-subhed">{header.subhed}</h3>
	{/if}
	{#if header.legend.length > 0}
		<div class="graphic-key">
			{#each header.legend as key}
				<div class="key-holder">
					{#if !key.color.includes('#')}
						<span
							class="key-circle"
							style="background-color: var(--{key.color})"
							>&nbsp;</span
						>
					{:else}
						<span
							class="key-circle"
							style="background-color: {key.color};">&nbsp;</span
						>
					{/if}

					<p class="key-text">{key.text}</p>
				</div>
			{/each}
		</div>
	{/if}
</div>

<style type="text/scss">
	.graphic-header {
		text-align: center;
		justify-content: center;
		font-family: var(--sans);
		margin-bottom: 2em;
		h1.graphic-hed {
			font-family: var(--sans);
			font-weight: 800;
			font-style: normal;
			font-size: 23px;
			text-align: center;
			margin: 0 auto 2px;
			max-width: 500px;
		}
		h3.graphic-subhed {
			font-family: var(--sans);
			font-style: normal;
			font-weight: 400;
			font-size: 15px;
			line-height: 18px;
			margin: 0px 0 10px;
		}
		.graphic-key {
			margin: 0 auto;
			padding: 0;
			text-align: center;
			justify-content: center;
			flex-wrap: wrap;
			max-width: 500px;
			line-height: 1;
			.key-holder {
				margin: 0px auto 0.1rem;
				line-height: 1;
				display: inline-block;
				.key-text,
				span.key {
					display: inline-block;
					vertical-align: middle;
				}
				.key-text {
					font-family: var(--sans);
					font-size: 13px;
					font-weight: 500;
					margin: 0 15px 0 5px;
				}
				span.key {
					width: 5px;
					height: 5px;
					padding: 5px;
					border-radius: 50%;
				}
				span.key-circle {
					/*padding: 0px 9px;*/
					font-size: 13px;
					height: 1rem;
					width: 1rem;
					line-height: 1rem;
					display: inline-block;
					border-radius: 50%;
					background-color: #fff;
				}
			}
		}
	}
</style>
